export const INSITUTION_LIST_REQUEST = "INSITUTION_LIST_REQUEST";
export const INSITUTION_LIST_SUCCESS = "INSITUTION_LIST_SUCCESS";
export const INSITUTION_LIST_FAILURE = "INSITUTION_LIST_FAILURE";
export const CLEAR_INSITUTION_LIST = "CLEAR_INSITUTION_LIST";


// INSTITUIION BASIC UPDATE 
export const CREATE_INSITUTION_REQUEST = "CREATE_INSITUTION_REQUEST";
export const CREATE_INSITUTION_SUCCESS = "CREATE_INSITUTION_SUCCESS";
export const CREATE_INSITUTION_FAILURE = "CREATE_INSITUTION_FAILURE";



// INSTITUIION  DISTRICT  
export const DISTRICT_LIST_REQUEST = "DISTRICT_LIST_REQUEST";
export const DISTRICT_LIST_SUCCESS = "DISTRICT_LIST_SUCCESS";
export const DISTRICT_LIST_FAILURE = "DISTRICT_LIST_FAILURE";


export const SPORT_LIST_REQUEST = "SPORT_LIST_REQUEST";
export const SPORT_LIST_SUCCESS = "SPORT_LIST_SUCCESS";
export const SPORT_LIST_FAILURE = "SPORT_LIST_FAILURE";


export const AMENITIES_LIST_REQUEST = "AMENITIES_LIST_REQUEST";
export const AMENITIES_LIST_SUCCESS = "AMENITIES_LIST_SUCCESS";
export const AMENITIES_LIST_FAILURE = "AMENITIES_LIST_FAILURE";

// INSTITUTION DOC UPDATE
export const CREATE_INSITUTION_DOC_REQUEST = "CREATE_INSITUTION_DOC_REQUEST";
export const CREATE_INSITUTION_DOC_SUCCESS = "CREATE_INSITUTION_DOC_SUCCESS";
export const CREATE_INSITUTION_DOC_FAILURE = "CREATE_INSITUTION_DOC_FAILURE";

export const CORRECTION_LIST_REQUEST = "CORRECTION_LIST_REQUEST";
export const CORRECTION_LIST_SUCCESS = "CORRECTION_LIST_SUCCESS";
export const CORRECTION_LIST_FAILURE = "CORRECTION_LIST_FAILURE";







